import { Component, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';

@Component({
  selector: 'app-no-data-found',
  standalone: true,
   schemas: [CUSTOM_ELEMENTS_SCHEMA],
  imports: [],
  templateUrl: './no-data-found.component.html',
  styleUrl: './no-data-found.component.scss'
})
export class NoDataFoundComponent {

}
